export enum CheckoutOptimizationAttestationSource {
  Split = "split",
  Admin = "admin",
}
